import { CardInfo, OrderPayment } from '@/components'

import styles from './card-order-payment-progress.module.css'

import type { CardOrderPaymentProgressProps } from './card-order-payment-progress.type'

export const CardOrderPaymentProgress = ({
  isLoading,
  saleOrder,
}: CardOrderPaymentProgressProps) => {
  return (
    <div className={styles.core}>
      <CardInfo isLoading={isLoading}>
        <OrderPayment
          isLoading={isLoading}
          saleOrder={saleOrder}
          showTransactions={false}
          showPaymentCondition={false}
        />
      </CardInfo>
    </div>
  )
}
